import React from 'react'
// import { connect } from 'react-redux';
// import { reduxForm, Field } from 'redux-form';
import ModalTriggerTextField from './ModalTriggerTextField'
// import DropDownMenu from './DropDownMenu';
import ModalContent from './ModalContent'

class PassengerCabinField extends React.Component {
  render () {
    // const { selectFieldName } = this.props;

    return (
      <div>
        <ModalTriggerTextField
          content={<ModalContent />}
          />
        {/*          <DropDownMenu
            dropDownMenuContent={<DropDownMenuContent />}
          /> */}
      </div>
    )
  }
}

export default PassengerCabinField

// // Decorate with redux-form
// PassengerCabinField = reduxForm({
//   form: 'passengerCabinFieldControlled'
// })(PassengerCabinField)

// function mapStateToProps(state) {

//   return {
//     // passenger_cabin_text_val: state.form.passengerCabinField ? state.form.passengerCabinField.text_val : 'Coach, 1 Adult',
//     initialValues: {'passenger_cabin_select': 'Coach'} // Set default value of passenger/cabin field to Coach
//   }
// }

// export default connect(mapStateToProps)(PassengerCabinField);



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/PassengerCabinField/index.js